import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase,
  InspectionVolumeCase
} from '../inspection-cases';

export class AerosolDto extends InspectionCase {
  basedOnPrEngineerSystem?: InspectionValueCase;
  boardDetailsOrProtectedSpace?: InspectionValueCase;
  boardDimensions?: InspectionVolumeCase;
}

export class Aerosol extends AerosolDto {
  constructor(data: AerosolDto = { title: 'מערכת כיבוי באמצעות אירוסול' }) {
    super(data);
    this.basedOnPrEngineerSystem = new InspectionValueCase({
      ...data.basedOnPrEngineerSystem,
      title: `המערכת מבוססת על מערכת Pre-Engineer של חברת`
    });
    this.boardDetailsOrProtectedSpace = new InspectionValueCase({
      ...data.boardDetailsOrProtectedSpace,
      title: `פרטי הלוח / החלל המוגן`
    });
    this.boardDimensions = new InspectionVolumeCase({
      ...data.boardDimensions,
      title: `ממדי לוח / חדר החשמל / תקשורת , הינם`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.basedOnPrEngineerSystem.isApplicable ||
        this.basedOnPrEngineerSystem.isPassed) &&
        (!this.boardDetailsOrProtectedSpace.isApplicable ||
          this.boardDetailsOrProtectedSpace.isPassed) &&
        (!this.boardDimensions.isApplicable || this.boardDimensions.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.basedOnPrEngineerSystem.getNotes(),
      ...this.boardDetailsOrProtectedSpace.getNotes(),
      ...this.boardDimensions.getNotes()
    ];
  }
}
